export default __webpack_public_path__ + "static/media/check-circle-pink.f261fb87.svg";